import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import { useDeleteOrderProductMutation, useGetAllRequestedQuery, useGetOrderProductsQuery, useModifyRequestOrderDetailsMutation, useModifyRequestOrderMutation, useUpdateOrderProductMutation } from '../../store/api/orderProductApi'
import { FaCheckCircle, FaRegEdit } from 'react-icons/fa'
import { FaCheck } from 'react-icons/fa'
import Swal from 'sweetalert2'
import { useGetNotificationsQuery } from '../../store/api/notificationApi'
import { useGetProductsQuery } from '../../store/api/productsApi'
import { FaBoxOpen } from 'react-icons/fa6'
import Select from 'react-select'
import { useGetSuppliersQuery } from '../../store/api/supplierApi'
import { useGetUserRolesQuery } from '../../store/api/userAuthApi'
import Logo from '../tools/Logo'
import { Link } from 'react-router-dom'
import PDFRecievedPurchaseOrderGenerator from '../tools/PDFRecievedPurchaseOrderGenerator'
import AllPurchaseExcel from '../tools/AllPurchaseExcel'
import { FaDownLong } from 'react-icons/fa6'


const orderQty = {
  Id: 0,
  ProductsId: null,
  SupplierId: null,
  Requestedqty: 0,
  Recievedqty: 0,
  Amount: "",
  oldrecievedqty: 0
}


const initialVlaues = {
  isAdmin: false,
  isStoreKeeper: true,
};

export default function RequestedProducts() {
  let userLogedInId = localStorage.getItem("UserData") != null ? JSON.parse(localStorage.getItem("UserData")).id == null ? 0 : JSON.parse(localStorage.getItem("UserData")).id : 0;

  const userRoles = useGetUserRolesQuery(userLogedInId, { pollingInterval: 10000 }).data;
  var userRolesData = userRoles ?? [];

  userRolesData.map((user) => (
    user.roles.map((role) => {
      if (role.isAdmin === true) {
        initialVlaues.isAdmin = role.isAdmin;
        initialVlaues.isStoreKeeper = false;
      } else if (role.isStoreKeeper === true) {
        initialVlaues.isStoreKeeper = role.isStoreKeeper;
        initialVlaues.isAdmin = false;
      }

      return role.id;
    })
  ))
  const { data: supplier } = useGetSuppliersQuery({
    refetchOnMountOrArgChange: true
  });
  useEffect(() => {
    if (supplier) {
      setSuppliers(supplier)
    }
  }, [supplier]);
  const [formData, setFormData] = useState({
    Id: 0,
    genId: null,
    requestedqty: 0,
    ProductsId: null,
    supplierId: null
  })
  const [suppliers, setSuppliers] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [open, setOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);
  const { refetch: refetchNotifications } = useGetNotificationsQuery()
  const { refetch: refetchProducts } = useGetProductsQuery()
  const { refetch: refetchGetAllRequested } = useGetAllRequestedQuery()
  const [orderedQty, setOrderedQty] = useState(orderQty)
  const [updateOrderProduct] = useUpdateOrderProductMutation();
  const [modifyRequestOrders] = useModifyRequestOrderMutation()
  const [modifyRequestOrderDetail] = useModifyRequestOrderDetailsMutation()
  const [orderedProduct, setOrderedProduct] = useState([])
  const [deleteRequestedProduct] = useDeleteOrderProductMutation()

  const {
    data: ordered,
    error,
    isLoading,
    refetch: refetchOrderProducts
  } = useGetOrderProductsQuery();

  useEffect(() => {
    if (ordered) {
      setOrderedProduct(ordered)
    }
  }, [ordered])




  const [isConfirmed, setIsConfirmed] = useState(false)
  const [isWaiting, setIsWaiting] = useState(false)
  const [isRed, setRed] = useState(false)

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="color-text fs-4">Loading...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="row">
          <div className="col-12 opacity-75 bg-light p-4 rounded-3 shadow-md border">
            <h3 className="text-danger">Opps!!!</h3>
            <span className="fs-4">
              <span className="text-danger"> An Error has occurred</span>
            </span>
            <div className="fs-5"> The server is shut down 😢</div>
          </div>
        </div>
      </div>
    )
  }

  const handleCheckboxChange = () => {
    setIsConfirmed(!isConfirmed);
  }
  const handleCheckWaitingBoxChange = () => {
    setIsWaiting(!isWaiting);
  }

  const handleUnassign = async (data) => {

    const requestData = {
      Id: data.id,
      name: data.name,
      ProductsId: data.proId,
      SupplierId: data.supId,
      Requestedqty: data.requestedQty,
      Recievedqty: data.recieved,
      Amount: data.amount,
      IsArrived: true,
      isWaiting: false
    }
    delete requestData.name;

    try {

      Swal.fire({
        title: 'Are you sure?',
        text: 'you want to confirm that you are not waiting for any quantities !!!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#022B3A',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Confirm it!'
      }).then((result) => {
        if (result.isConfirmed) {
          updateOrderProduct(requestData).then((done) => {

            if (done.data.status === 200) {
              Swal.fire({
                title: 'Success!',
                text: "You Confirmation has been successfully done",
                icon: 'success',
                confirmButtonText: 'Done'
              })

            } else {
              Swal.fire({
                title: 'Error!',
                text: done.data.message,
                icon: 'error',
                confirmButtonText: 'close'
              })
            }
          })
        }
      })

    } catch (error) {
    }
    await refetchGetAllRequested()
    await refetchNotifications()
    await refetchProducts()

  }


  const handleUpdate = (updateData) => {

    setIsConfirmed(false)
    setOrderedQty({
      Id: updateData.id,
      name: updateData.name,
      ProductsId: updateData.proId,
      SupplierId: updateData.supId,
      Requestedqty: updateData.requestedQty,
      oldrecievedqty: updateData.recievedQty,
      Recievedqty: "",
      Amount: updateData.amount,
      unit: updateData.unit
    });

    setIsWaiting(updateData.isWaiting === 'waiting for quantities' ? true : false)

  }

  //  console.log((parseInt(orderedQty.Recievedqty) + parseInt(orderedQty.oldrecievedqty)) == parseInt(orderedQty.Requestedqty) ? false : isWaiting);

  const handleUpdateProductSupplier = async () => {
    if (isConfirmed) {
      const requestData = {
        ...orderedQty, IsArrived: isConfirmed, isWaiting: (parseInt(orderedQty.Recievedqty) + parseInt(orderedQty.oldrecievedqty)) == parseInt(orderedQty.Requestedqty) ? false : isWaiting
      }
      delete requestData.name;
      delete requestData.oldrecievedqty;

      try {
        if (requestData.SupplierId !== null) {
          await updateOrderProduct(requestData).then((done) => {

            if (done.data.status === 200) {
              Swal.fire({
                title: 'Success!',
                text: done.data.message,
                icon: 'success',
                confirmButtonText: 'Done'
              })

            } else {
              Swal.fire({
                title: 'Error!',
                text: done.data.message,
                icon: 'error',
                confirmButtonText: 'close'
              })
            }
          })
        } else {
          Swal.fire({
            title: 'Error!',
            text: "Unknown supplier",
            icon: 'error',
            confirmButtonText: 'close'
          })
        }

      } catch (error) {
        console.log(error);
      }
      await refetchGetAllRequested()
      await refetchNotifications()
      await refetchProducts()
      setRed(!isRed);
    } else {
      setRed(!isRed);
    }


  }


  const handleUpdatePurchase = (row) => {
    setFormData(
      {
        Id: row.id,
        genId: row.genId,
        requestedqty: row.requestedQty,
        ProductsId: row.proId,
        supplierId: null,

      }
    )
  }

  const handleSupplierSelectChange = (name, selectedOption) => {
    setFormData({
      ...formData,
      [name]: selectedOption.value,
      supplierName: selectedOption.label
    })
  }



  const handleDelete = (value) => {

    console.log(value);
    
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this request details !!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#022B3A',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        deleteRequestedProduct(value).then((done) => {
          if (done?.data.status === 200) {
            refetchNotifications();
            Swal.fire({
              title: 'Success!',
              text: done.data.message,
              icon: 'success',
              confirmButtonText: 'Done'
            })
          } else {
            Swal.fire({
              title: 'Error!',
              text: done.data.message,
              icon: 'error',
              confirmButtonText: 'Close'
            })
          }
        })
      }
    })
  }



  const _columns = initialVlaues.isAdmin === true ? [
    // { name: 'Id', selector: (row) => 1, sortable: true, center: true },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      center: true
    },
    {
      name: 'Quantity',
      selector: (row) => row.requestedQty,
      sortable: true,
      center: true
    },
    {
      name: 'Unit',
      selector: (row) => row.unit,
      sortable: true,
      center: true
    },
    {
      name: 'Recieved',
      selector: (row) => row.recievedQty,
      sortable: true,
      center: true
    },
    {
      name: 'In waiting',
      selector: (row) => row.isWaiting,
      sortable: true,
      center: true
    },
    {
      name: 'Status',
      selector: (row) => row.isArrived,
      cell: (row) => (
        <span className="w-100 p-1 rounded-2 bg-danger opacity-50  text-center text-white  text-capitalize">
          {row.isArrived}
        </span>
      ),
      sortable: true,
      center: true
    },
    // {
    //   name: 'Supplier',
    //   selector: (row) => row.supplier,
    //   sortable: true,
    //   center: true
    // },
    {
      name: 'Amount',
      selector: (row) => `$${(+row.amount || 0).toFixed(2)}`,
      sortable: true,
      center: true
    },
    // {
    //   name: 'Category',
    //   selector: (row) => row.category,
    //   sortable: true,
    //   center: true
    // },

    {
      name: 'Create At',
      selector: (row) => row.created,
      sortable: true,
      center: true
    },

    {
      name: 'Actions',
      cell: (row) => (
        <>
          <button
            style={{ background: '#1b263b' }}
            className="btn btn-success me-2 border-0 text-white"
            onClick={(e) => handleUnassign(row)}
          >
            <Logo _width={20} name={'../image/icons/unassign.svg'} _height={20} _color={'#FFFFFF'} />

          </button>
          <button
            style={{ background: '#1a2131' }}
            className="btn btn-success me-3 border-0  text-white"
            data-bs-toggle="modal"
            data-bs-target="#modal-fromleft"
            onClick={() => handleUpdatePurchase(row)}
          >
            <FaRegEdit />
          </button>

          <button
            className="btn btn-success  btn-sm p-2 px-3  fs-6 text-white "
            data-bs-toggle="modal"
            data-bs-target="#modal-fromright"
            onClick={() => handleUpdate(row)}
          >

            <FaBoxOpen />

          </button>
        </>
      ),
      center: true
    }

  ] : [
    //{ name: 'Id', selector: (row) => row.id, sortable: true, center: true },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      center: true
    },
    {
      name: 'Quantity',
      selector: (row) => row.requestedQty,
      sortable: true,
      center: true
    },
    {
      name: 'Unit',
      selector: (row) => row.unit,
      sortable: true,
      center: true
    },
    {
      name: 'Recieved',
      selector: (row) => row.recievedQty,
      sortable: true,
      center: true
    },
    {
      name: 'In waiting',
      selector: (row) => row.isWaiting,
      sortable: true,
      center: true
    },
    {
      name: 'Status',
      selector: (row) => row.isArrived,
      cell: (row) => (
        <span className="w-100 p-1 rounded-2 bg-danger opacity-50  text-center text-white  text-capitalize">
          {row.isArrived}
        </span>
      ),
      sortable: true,
      center: true
    },

    {
      name: 'Create At',
      selector: (row) => row.created,
      sortable: true,
      center: true
    },



  ];

  // modify

  const handleFormChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value
    })
  }



  const supplierOptions = suppliers.map((con) => ({
    value: con.id,
    label: con.name
  }));




  const canSave = [
    isConfirmed,
    orderedQty.Recievedqty,
    orderedQty.Amount
  ].every(Boolean)



  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = orderedProduct.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    const totalPages = Math.ceil(orderedProduct.length / newItemsPerPage);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page

    // If the current page is greater than the new total pages, set current page to the last page
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  };



  const SendRequestOrder = async () => {

    const requestData = {
      supplierId: formData.supplierId,
      genId: formData.genId,
      usersId: userLogedInId,
    };

    const savedOrderData = await modifyRequestOrders(requestData);

    return savedOrderData;
  };



  const ModifyRequestOrder = async (event) => {

    event.preventDefault();
    let allSuccess = true;
    let msg = '';

    const productOrderResponse = await SendRequestOrder();

    if (productOrderResponse.data.status === 200) {
      delete formData.ProductsId;
      delete formData.supplierId;
      delete formData.genId;

      const movementResponse = await modifyRequestOrderDetail({ ...formData });

      if (movementResponse.data.status !== 200) {
        allSuccess = false;
        msg = movementResponse.data.message;

      } else {
        msg = movementResponse.data.message;
      }

      await refetchGetAllRequested();
      await refetchOrderProducts();

      if (allSuccess) {

        Swal.fire({
          title: 'Success!',
          text: msg,
          icon: 'success',
          confirmButtonText: 'Done'
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: msg,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    }
    setFormData(initialVlaues)
  }

  const resetModalform = () => {
    setOrderedQty(orderQty);
  }



  const showData = (index) => {
    setOpenIndex(index);
    setOpen(!open);
  }
  const getRequestDate = (date) => {
    const [year, month, day] = date.split('-').map(Number);
    const dt = new Date(year, month - 1, day);
    return dt.toDateString();
  }


  const canEdit = [formData.supplierId, formData.requestedqty].every(Boolean)



  return (
    <div>

      <div className="block-content block-content-full">
        <h2 className="content-heading text-uppercase">UnRecieved Purchased Orders</h2>
      </div>

      <div className="block1">
        <div className="block-content block-content-full">

          <div className="row text-white p-2 pb-0 border-0 mx-1 mb-0" style={{ backgroundColor: '#01574E' }}>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className='mx-xl-5'>Invoice Id</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className='mx-xl-5'>Supplier</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className='mx-xl-5'>Category</h6>
            </div>
            <div className="col-md-3 col-lg-3 col-sm-3 col-xl-3 col-3">
              <h6 className='text-center mx-3'>Date</h6>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 col-12">
              {
                currentItems.map((list, index) => {

                  return <div className="card mt-3">
                    <div className="card-header">
                      <div class="row">
                        <div class="col-md-3 col-lg-3 col-sm-12 col-xl-3 col-12">
                          <div className='d-flex justify-content-start'>
                            <button
                              className="btn btn-link bg-"
                              onClick={(e) => showData(index)}
                              aria-controls="example-collapse-text"
                              aria-expanded={open}
                            >
                              {open && index === openIndex ? <span>&#9660;</span> : <span>&#9650;</span>}
                            </button>
                            <h6 className='mt-3'>{list[0]?.genId}</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-lg-3 col-sm-12 col-xl-3 col-12 ">
                          <h6 className='mt-3  mx-3'> {list[0]?.supplier === null ? "Not Sent To Supplier" : list[0]?.supplier}</h6>
                        </div>
                        <div className="col-md-3 col-lg-3 col-sm-12 col-xl-3 col-12">
                          <h6 className='mt-3  mx-3'> {list[0]?.category}</h6>
                        </div>

                        <div className="col-md-3 col-lg-3 col-sm-12 col-xl-3 col-12 d-flex justify-content-start">
                          <h6 className='mt-3 text-xl-end  mx-3'> {getRequestDate(list[0]?.created)}</h6>
                          <Link className="text-dark fs-5 text-decoration-none position-absolute top-0 end-0 bg-dark1 p-2 rounded-2 pb-0 pt-0 mt-2 me-2" onClick={(e) => handleDelete(list[0]?.genId)}>
                            <i className='text-danger fa fa-trash'></i>
                          </Link>
                        </div>
                       
                      </div>
                    </div>
                    {open && index === openIndex && (
                      <div id="example-collapse-text" className="collapse show">
                        <div className="card-body">
                          <div className="d-flex justify-content-end mb-2">
                            <button
                              title="Download PDF"
                              className="btn bg-success border-0 me-2 p-1"
                              onClick={() => PDFRecievedPurchaseOrderGenerator(list)}
                            >
                              <Logo
                                _width={25}
                                name={"../../../image/icons/download.svg"}
                                _color={"#01574E"}
                                _height={20}
                                _marginLeft={0}
                              />
                            </button>
                            <button
                              style={{
                                background: "#1a2131",
                              }}
                              className="btn btn-success border-0 text-white p-1 px-2"
                              onClick={() => AllPurchaseExcel(list, false)}
                            >
                              <FaDownLong /> Excel
                            </button>
                          </div>

                          <DataTable
                            columns={_columns}
                            data={list}

                          />

                        </div>
                      </div>
                    )}
                  </div>
                })
              }
            </div>

            {
              currentItems.length ? <div className='mt-4'>
                <ul className="pagination justify-content-end">

                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                  </li>
                  <li className="page-item disabled">
                    <span className="page-link">{currentPage}</span>
                  </li>
                  <li className={`page-item ${currentItems.length < itemsPerPage ? 'disabled' : ''} ${currentItems.length === orderedProduct.length ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                  </li>
                  <li className="page-item mx-2">
                    <select className="form-select p-0 px-5 py-1 rounded-0" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="30">30</option>
                      <option value="40">40</option>
                      <option value="50">50</option>
                    </select>
                  </li>
                </ul>
              </div> : <></>
            }
          </div>
          {/*  */}

          <div
            class="modal fade"
            id="modal-fromright"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-fromright"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-fromright" role="document">
              <div class="modal-content">
                <div class="block block-themed block-transparent mb-0">
                  <div class="block-header bg-primary-dark">
                    <h3 class="block-title">Save for the recieved quantities . . .</h3>
                    <div class="block-options">
                      <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                        <i class="si si-close"></i>
                      </button>
                    </div>
                  </div>
                  <div class="block-content">
                    <form encType="multipart/form-data">
                      <div className="row">
                        <div className="col-sm-12 hover">
                          <div className="mb-3">
                            <div className="row">
                              <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                Requested Product
                              </label>
                            </div>
                            <div className="d-flex justify-content-between">
                              <h5>{orderedQty.name}</h5>
                              <FaCheckCircle style={{ color: 'green' }} />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 hover">
                          <div className="mb-3">
                            <div className="row">
                              <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                Requested quantities
                              </label>
                            </div>
                            <div className="d-flex justify-content-between">
                              <h5>{orderedQty.Requestedqty}{" "}{orderedQty.unit}</h5>
                              <FaCheckCircle style={{ color: 'green' }} />
                            </div>
                          </div>
                        </div>



                        <div className={orderedQty.oldrecievedqty > 0 && orderedQty.oldrecievedqty < orderedQty.Requestedqty ? "col-sm-12 hover" : "d-B"}>
                          <div className="mb-3">
                            <div className="row">
                              <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                Old Recieved  Quantity
                              </label>
                            </div>
                            <div className="d-flex justify-content-between">
                              <h5>you have already recieved {orderedQty.oldrecievedqty} quantities</h5>
                              <FaCheckCircle style={{ color: 'green' }} />
                            </div>

                          </div>
                        </div>

                        <div className="col-sm-12 hover">
                          <div className="mb-3">
                            <div className="row">
                              <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                {orderedQty.oldrecievedqty > 0 && orderedQty.oldrecievedqty < orderedQty.Requestedqty ? "New Recieved Quantity" : "Recieved Quantity"}
                              </label>
                            </div>
                            <div className="input-group">
                              <input
                                type="number"
                                style={{ height: '45px' }}
                                max={orderedQty.Requestedqty}
                                min={1}
                                autoComplete='off'
                                className="form-control numericInput"
                                id="exampleFormControlInput1"
                                placeholder="New Recieved quantity"
                                value={orderedQty.Recievedqty}
                                onChange={(e) => {

                                  setOrderedQty({ ...orderedQty, Recievedqty: orderedQty.oldrecievedqty > 0 ? parseInt(e.target.value) > orderedQty.Requestedqty - orderedQty.oldrecievedqty ? 0 : parseInt(e.target.value) : parseInt(e.target.value) > orderedQty.Requestedqty ? orderedQty.Recievedqty : parseInt(e.target.value) })
                                }}
                              />
                            </div>
                            {
                              orderedQty.Recievedqty === 0 ? (<span className='text-danger'>The remained quantities are needed</span>) : <></>
                            }

                          </div>
                        </div>

                        <div className="col-sm-12 hover mb-3">
                          <div className="row ">
                            <label htmlFor="notificationQuantity" className="form-label text-start">
                              How much it custs? (optional)
                            </label>
                          </div>
                          <div className="input-group">
                            <input
                              placeholder="How much it custs?"
                              pattern="[0-9]*"
                              inputMode="numeric"
                              name="movementQty"
                              style={{ height: '45px' }}
                              type="number"
                              min={'1'}
                              className="form-control numericInput"
                              id="notificationQuantity"
                              value={orderedQty.Amount}
                              onChange={(e) =>
                                setOrderedQty({
                                  ...orderedQty,
                                  Amount: e.target.value
                                })
                              }
                            />
                          </div>
                        </div>


                        <div className={orderedQty.Requestedqty === orderedQty.Recievedqty || orderedQty.oldrecievedqty + orderedQty.Recievedqty === orderedQty.Requestedqty ? "d-none" : "col-sm-12 hover"}>
                          <div className="mb-3">

                            {/* <div className="row">
                              <label htmlFor="notificationQuantity" className="form-label text-start">
                                Confirm for waiting some quantities?
                              </label>
                            </div> */}

                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" checked={isWaiting}
                                onChange={handleCheckWaitingBoxChange} id="isWaitingforqty" />
                              <label class="form-check-label d-flex" for="isWaitingforqty">
                                {isWaiting ? (
                                  <span style={{ color: 'green' }}>
                                    <FaCheck /> Confirmed for waiting for some quantities
                                  </span>
                                ) : (<h6 className={isRed ? 'text-danger' : 'text-dark'}>Are you wating for quantities?</h6>)}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 hover">
                          <div className="mb-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" checked={isConfirmed}
                                onChange={handleCheckboxChange} id="flexCheckChecked" />
                              <label class="form-check-label d-flex" for="flexCheckChecked">
                                {isConfirmed ? (
                                  <span style={{ color: 'green' }}>
                                    <FaCheck /> Confirmed
                                  </span>
                                ) : (<h6 className={isRed ? 'text-danger' : 'RED'}>Are you sure this is the received quantity?</h6>)}
                              </label>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={resetModalform}>
                          Close
                        </button>
                        <input
                          type={isConfirmed ? "button" : "button"}
                          class="btn btn-primary "
                          data-bs-dismiss={isConfirmed ? "modal" : ""}
                          onClick={handleUpdateProductSupplier}
                          value="Save changes"
                          disabled={!canSave}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*  */}

          {/*  */}
          <div
            class="modal fade"
            id="modal-fromleft"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-fromleft"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-fromright" role="document">
              <div class="modal-content">
                <div class="block block-themed block-transparent mb-0">
                  <div class="block-header bg-primary-dark">
                    <h3 class="block-title">Modify Purchase Order</h3>
                    <div class="block-options">
                      <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                        <i class="si si-close"></i>
                      </button>
                    </div>
                  </div>
                  <div class="block-content">
                    <form encType="multipart/form-data">

                      <div className="row">
                        <div className="mt-2">
                          <label htmlFor="" className="form-label text-start">
                            Supplier
                          </label>
                          <Select

                            options={supplierOptions}
                            value={supplierOptions.find((option) => option.value === formData.supplierId)}
                            onChange={(selectedOption) => handleSupplierSelectChange('supplierId', selectedOption)}
                            placeholder="Select Supplier"
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                height: "45px",
                              }),
                            }}
                          />
                        </div>

                        <div className="mt-2">
                          <div className="row">
                            <label htmlFor="notificationQuantity" className="form-label text-start">
                              How many quantity?
                            </label>
                          </div>
                          <div className="input-group">
                            <input

                              name="requestedqty"
                              style={{ height: '45px' }}
                              type="number"
                              min={1}
                              className="form-control numericInput"
                              id="notificationQuantity"
                              value={formData.requestedqty}
                              onChange={handleFormChange}
                            />
                          </div>
                        </div>
                      </div>

                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                          Close
                        </button>
                        <input
                          type={"button"}
                          class="btn btn-primary "
                          data-bs-dismiss="modal"
                          onClick={ModifyRequestOrder}
                          value="Save changes"
                          disabled={!canEdit}
                        />
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*  */}
        </div>
      </div>
    </div>
  )
}
